export function trueToBoolean(s?: string) {
    return s === undefined ? undefined : s === "true";
}
